import * as _ from 'lodash';
import { ActivatedRouteSnapshot } from '@angular/router';

export function findParamInSnapshot(route: ActivatedRouteSnapshot, paramName: string): string {
    return findInSnapshot('params')(route, paramName);
}

export function findQueryParamInSnapshot(route: ActivatedRouteSnapshot, paramName: string): string {
    return findInSnapshot('queryParams')(route, paramName);
}

export function findDataInSnapshot(route: ActivatedRouteSnapshot, dataPropertyName: string): any {
    return findInSnapshot('data')(route, dataPropertyName);
}

export function getFilenameFromURL(url: string): string {
    return url.split('/').pop();
}

function findInSnapshot(routePropertyName: 'data' | 'params' | 'queryParams') {
    return (route: ActivatedRouteSnapshot, propertyName: string): any => {
        // Traverse to the deepest active route first (child routes override parent routes)
        if (route.firstChild) {
            const childValue = findInSnapshot(routePropertyName)(route.firstChild, propertyName);
            if (childValue !== null && childValue !== undefined) {
                return childValue;
            }
        }

        // If not found in children, check current route
        // Angular merges parent route data, so this includes parent values
        const value = _.get(route, `${routePropertyName}.${propertyName}`);
        if (value !== null && value !== undefined) {
            return value;
        }

        return null;
    };
}
